// 车牌识别
export default {
    licensePlate: 'License Plate',
    pictureName: 'Picture Name',
    identificationPeriod: 'Identification Period',
    identified: 'Identified',
    unrecognized: 'Unrecognized',
    IR: 'Identification results',
    reliability: 'Reliability',
    LPR: 'LPR',
    PEAN: 'Please enter a name',
    TLIB: 'The length is between 1 and 20 characters',
}